export default __webpack_public_path__ + "static/media/blackPT.2b2144e1.png";